import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';
import moment from 'moment';

const CreatedField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	const inputValue = dishForFullInfo?.insertedDate
		? `${moment(dishForFullInfo.insertedDate).format('MM/DD/YYYY h:mm:ss A')}   ${dishForFullInfo.insertedBy}`
		: undefined;

	return <FullInfoField label="createdLabel" value={inputValue} />;
};

export default CreatedField;
